export const getDefaultColumns = (data) => {
    let columns = []
    let dati = data[0]
    for (const key in dati)
    {
        columns.push( { Header: key, accessor: key } )
    }

    return columns
}